// FileViewerModal.js
import React, { useEffect, useState, useRef } from "react";
import { Modal, Box, Backdrop, CircularProgress } from "@mui/material";
import { isEmptyDash, urlConstants } from "../../constant";
import AlertComponent from "../alert/alert";

import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { UserObj } from "../../services/localStarage";
import _ from "lodash";

const requestesignstyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};


const PDFPreview = (props) => {
  const userRole = UserObj ? UserObj?.role?.name : "";
  const [fileSrc, setfileSrc] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const handleCloseAlert = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  const submit = (param) => {
    if (isChecked == true) {
      props.submitSign();
    }
  }

  useEffect(() => {
    if (!isEmptyDash(props?.purchaseOrderIds) && props.isOpen == true) {
      downloadPO();
    }
  }, [props?.purchaseOrderIds, props.isOpen]);

  const downloadPO = () => {
    setIsLoading(true);
    let bodyData = {
      // "purchaseOrderIds": [props?.purchaseOrderIds],
      "poNumber": props?.poDetails?.poNumber,
      "type": "po-pdf", // "line-item", header, po-pdf
    };

    let url = `${urlConstants.BASE_URI_DEV}/v1/common/purchase-orders/download`;
    let myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${UserObj?.accessToken}`);
    myHeaders.append("Content-Type", "application/json");
    let raw = JSON.stringify(bodyData);

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(url, requestOptions)
      .then(response => {
        if (response.status === 400) {
          throw new Error(`Bad Request: ${response.status}`);
        }
        return response.blob();
      })
      .then(blob => {
        const urlInit = URL.createObjectURL(blob);
        setfileSrc(urlInit);
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `There is some error to download file. ` });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const closeModal = (e) => {
    props.closeRequestSign();
    setfileSrc(null);
    setIsChecked(false);
  };

  const onCheckChange = (e) => {
    let { checked } = e.target;
    setIsChecked(checked);
  };

  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  return (

    <div>
      <Modal
        open={props.isOpen}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={requestesignstyle}
          className="modal_react_controlpanel_employees"
        >
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel">
              PDF Preview
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              fdprocessedid="kum8iho"
              onClick={closeModal}
            ></button>
          </div>
          <div className="first_main_rowmodal">
            <div class="modal-body">
              <div className="rowmiles_order_reader">
                <div className="miles_order_reader w-100" >
                  {/* <img src={esignpdfImages} alt="" /> */}
                  {(fileSrc != null) && <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
                    <div style={{ height: "820px" }}>
                      <Viewer fileUrl={fileSrc} plugins={[defaultLayoutPluginInstance]} />
                    </div>
                  </Worker>}
                </div>

              </div>

              <div className="div-tnc">
                <div className="d-flex">
                  <div>
                    <input type="checkbox" checked={isChecked} onChange={onCheckChange} />
                  </div>
                  <div style={{ marginLeft: "10px" }}>
                    <h5>Terms & Conditions</h5>
                    <p>I confirm that I have read all the terms & Conditions & acknowledge the PO.</p>
                  </div>
                </div>
                <div className="card_tabs_milstone">
                  <button
                    class="btn btn-outline-secondary"
                    onClick={closeModal}
                  >
                    Discard
                  </button>

                  <button
                    type="button"
                    class="btn btn-success save_next_btns"
                    onClick={submit}
                    disabled={!isChecked}
                  >
                    Accept
                  </button>
                </div>
              </div>

            </div>
          </div>
        </Box>
      </Modal>
      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => 99999 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default PDFPreview;
